import { useState } from 'react';

import { AkaThemaId, ThemaFromThemaRouter } from '../../../dtos';
import { assertAkaThemaId } from '../../../utils/isAkaThemaId.ts';
import { getPendantLabel, isOnlineAndOrPraesenz } from '../../../utils/isOnline';

export const useOnlinePraesenzFilter = (thema: ThemaFromThemaRouter) => {
  const [selectedOptions, setSelectedOptions] = useState([thema.akaThemaId]);
  const isFullyOnline = isOnlineAndOrPraesenz(thema.isOnline, thema.planungsformat, thema.module) === 'ONLINE';

  const allOptions = [
    {
      label: isFullyOnline ? 'Online' : 'Präsenz',
      value: thema.akaThemaId,
    },
  ];
  if (thema.pendantThemen.length === 1) {
    const [pendant] = thema.pendantThemen;
    allOptions.push({ label: getPendantLabel(pendant), value: pendant.akaThemaId });
  }

  const toggleOption = (clickedOption: string) => {
    assertAkaThemaId(clickedOption);
    setSelectedOptions((prev: AkaThemaId[]) =>
      prev.includes(clickedOption) ? prev.filter((option) => option !== clickedOption) : [...prev, clickedOption],
    );
  };

  return { allOptions, selectedOptions, toggleOption };
};
